module.exports = __webpack_public_path__ + "static/media/J2.1a9cc535.png";